import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-mt-10 -mb-4" }

import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	
	const __default__ = { name: 'JobItems' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()

	const {t} = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table = _resolveComponent("tw-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noItems'),
      data: props?.job?.portalData?.portal_items,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('186'),
          prop: "job__job_item__ITEMS_UNIQUE__itemsUniqueID::item_display"
        }, null, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          header: _unref(store).getLabel('411')
        }, {
          default: _withCtx(({row}) => [
            (row['job__job_item__CONTACTS_SERVICES_ITEMS__contactServicesItemID::standard'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5 text-gray-300"
                }))
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"])
  ]))
}
}

})